import ReactTextareaAutocomplete from "@webscopeio/react-textarea-autocomplete";
import "@webscopeio/react-textarea-autocomplete/style.css";
import React, { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";

import { escapeRegExp } from "../../utils";
import { escapeNameForHumanTag } from "../../utils";
import { getNotesMeta } from "../../selectors/notesMeta";

const SCROLL_UI = `
  ::-webkit-scrollbar {
    width: 0.25rem;
    background-color: #eee;
  }
  ::-webkit-scrollbar-thumb {
    background: #343a40;
  }
`;

export const NotesTextarea = styled.div`
  > .rta {
    .human-list-wrapper {
      z-index: 100;
      max-height: 200px;
      overflow-x: hidden;
    }
    font-size: 1rem;
    > .rta__textarea {
      ${SCROLL_UI}
    }
  }
`;

export const List = styled.div`
  font-size: 1rem;
  padding: 0.375rem 0.625rem;
  line-height: 1;
  white-space: nowrap;
  > b {
    font-size: 0.875rem;
  }
`;

export const queryHumans = (humans, query) => {
  // convert "hello-world" to "hello\\s+world"
  const q = query
    .split(/[-_]+/)
    .map((i) => escapeRegExp(i))
    .join("\\s+");
  const valRegexp = new RegExp(q, "i");
  return humans.filter((human) => valRegexp.test(human.name));
};

const queryTags = (tagsOrdered, query) => {
  const valRegexp = new RegExp(escapeRegExp(query), "i");
  return tagsOrdered.filter((tag) => valRegexp.test(tag));
};

const SCList = ({ entity: { name, id } }) => (
  <List key={id}>
    <b>{name}</b>
  </List>
);
const TagList = ({ entity: tag }) => (
  <List key={tag}>
    <b>{tag}</b>
  </List>
);

TagList.propTypes = {
  entity: PropTypes.string,
};

SCList.propTypes = {
  entity: PropTypes.object,
};

const NoteInput = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [mentions, usertagsOrdered, tagsOrdered] = useSelector((state) =>
    getNotesMeta(state)
  );

  const textareaRef = useRef();

  useEffect(() => {
    if (!props.autoFocus || textareaRef.current === null) return;
    textareaRef.current.setCaretPosition(props.value ? props.value.length : 0);
    // props.value changes should be ignored, should run only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textareaRef, props.autoFocus]);

  return (
    <NotesTextarea>
      <ReactTextareaAutocomplete
        data-testid={`notes-input-textarea-${props.actiontype}`}
        name={"text"}
        className="w-full focus:ring-sky-500 focus:border-sky-500 border-white sm:text-sm rounded-lg shadow"
        dropdownClassName="human-list-wrapper"
        loadingComponent={() => <span>Loading</span>}
        trigger={{
          "@": {
            dataProvider: (val) => queryHumans(usertagsOrdered, val),
            component: SCList,
            output: (item, trigger) =>
              `${trigger}[${escapeNameForHumanTag(item.name)}](${item.id})`,
          },
          "#": {
            dataProvider: (val) => queryTags(tagsOrdered, val),
            component: TagList,
            output: (item, trigger) => item,
          },
        }}
        ref={textareaRef}
        {...props}
      />
    </NotesTextarea>
  );
};

NoteInput.propTypes = {
  autoFocus: PropTypes.bool,
  value: PropTypes.any,
  actiontype: PropTypes.string,
};
export default NoteInput;
